const arrowDropdown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="13.5 5.25 8 10.75 2.5 5.25"/></svg>',
};

export { arrowDropdown as default };
